import React, { useContext } from 'react';
import LocalizationContext from '../../contexts/Localizations';
import { DISCIPLINE } from '../../configs';
import Carousel from '../Carousel';
import { Image } from '../common';
import GatewayCarouselProps, { Card } from './type';
import './styles.scss';

export const GatewayCard = ({
  url,
  image,
  label,
  rider,
  discipline,
  openInNewTab,
}: Card, index: number) => {
  const { translations } = useContext(LocalizationContext);

  const Container: React.ReactType = url ? 'a' : 'div';

  return (
    <Container
      key={index}
      className={`gateway-carousel__card gateway-carousel__card--${discipline}`}
      href={url}
      target={openInNewTab ? '_blank' : '_self'}
    >
      <div className="gateway-carousel__card-container">
        {!label && rider && (
          <div className="gateway-carousel__card-ribbon">
            {translations.discipline[DISCIPLINE[discipline]]}
          </div>
        )}
        {image && (
          <div className="gateway-carousel__card-illustration">
            <Image
              url={image.file.url}
              alt={image.description as string}
              aspectRatio="4x5"
            />
          </div>
        )}

        {label && (
          <div className="gateway-carousel__card-label">
            {label}
          </div>
        )}
        {!label && rider && (
          <div className="gateway-carousel__card-rider">
            <div className="gateway-carousel__card-rider-firstname">
              {rider.firstname}
            </div>
            <div className="gateway-carousel__card-rider-lastname">
              {rider.lastname}
            </div>
            <div className="gateway-carousel__card-rider-description">
              {rider.description}
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

const GatewayCarousel = ({
  title,
  cards,
  themeColor,
}: GatewayCarouselProps) => {
  const slickConfig = {
    variableWidth: false,
    slidesToShow: 3.1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3.1,
          arrows: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.1,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.6,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          arrows: true,
        },
      },
    ],
  };

  return (
    <div className={`gateway-carousel gateway-carousel--${themeColor}`}>
      <div className="gateway-carousel__container">
        <Carousel
          title={title}
          slickConfig={slickConfig}
          containerTheme={themeColor}
          large
        >
          {cards.map(GatewayCard)}
        </Carousel>
      </div>
    </div>
  );
};

export default GatewayCarousel;
